



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mixin as clickaway } from 'vue-clickaway';
import { SettingsState } from '@/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { NETWORK_COMPONENT_ID } from '@/core/components/Network.vue';

@Component({
    mixins: [ clickaway ],
})
export default class Page extends Vue {
    @Prop({ type: String,  required: true }) public id!: string;
    @Prop({ type: String,  default: 'logo' }) public icon!: string;
    @Prop({ type: Boolean, default: true }) public canExpand!: boolean;
    @Prop({ type: Boolean, default: true }) public shouldCloseOnClickaway!: boolean;

    @Inject(CONTRACTS.WindowsService) public windowsService?: WindowsServiceContract;

    public close(): void {
        this.windowsService!.close(this.id!);
    }

    public updateCurrentTileKey(key: string = '') {
        this.windowsService!.storeCurrentTile(key);
    }

    public expand(): void {
        this.windowsService!.expand(this.id!);
    }

    public closeOnClickaway(mouseEvent: any) {
        const { shouldCloseOnClickaway } = this;
        // Check is needed to awoid false positives when clicking on interface elements.
        if (shouldCloseOnClickaway
            && mouseEvent.toElement
            && mouseEvent.toElement.id === NETWORK_COMPONENT_ID) {
            this.close();
        }
    }
}
